<div
  #scrollContainer
  class="relative h-[calc(100%-40px)] scrollbar"
  (scroll)="onScroll($event)"
>
  <!-- Sticky panel -->
  <div class="sticky top-0 z-20 bg-neutral-5 p-2">
    <kendo-textbox
      [placeholder]="searchPlaceholder"
      [clearButton]="true"
      [value]="searchInput"
      (valueChange)="onSearchInput($event)"
      class="small-placeholder"
    >
      <ng-template kendoTextBoxPrefixTemplate>
        <span
          class="fa-icons icon-14 icon-magnifying-glass text-neutral-60 ml-2"
        ></span>
      </ng-template>
    </kendo-textbox>

    <div class="pt-2">
      @if (entryType === EntryType.Opportunity && !this.isLoading.skeleton) {
        <p class="subtitle-2">
          {{ 'outlook.entries.opportunities' | translate }}
          <span class="text-neutral-90 text-body">
            {{
              'outlook.main.related.count'
                | translate
                  : {
                      count: displayedOpportunities.length,
                      total: opportunities.length,
                    }
            }}
          </span>
        </p>
      } @else if (entryType === EntryType.Case && !this.isLoading.skeleton) {
        <p class="subtitle-2">
          {{ 'cases' | translateVertical }}
          <span class="text-neutral-90 text-body">
            {{
              'outlook.main.related.count'
                | translate
                  : {
                      count: displayedCases.length,
                      total: cases.length,
                    }
            }}
          </span>
        </p>
      }
    </div>
  </div>

  <div class="p-2 flex flex-col gap-2">
    @if (isLoading.skeleton) {
      <maximizer-outlook-skeleton-card></maximizer-outlook-skeleton-card>
      <maximizer-outlook-skeleton-card></maximizer-outlook-skeleton-card>
    } @else {
      @if (isLoading.spinner) {
        <maximizer-loader type="legacy"></maximizer-loader>
      }
      @if (entryType === EntryType.Opportunity) {
        @if (opportunities.length === 0) {
          <div class="py-2">
            <p class="text-neutral-60 text-body">
              {{
                'outlook.main.related.noResults'
                  | translate
                    : {
                        label: 'outlook.entries.opportunities' | translate,
                      }
              }}
            </p>
          </div>
        } @else {
          @for (opportunity of displayedOpportunities; track opportunity.key) {
            <maximizer-outlook-opportunity-card
              [opportunity]="opportunity"
              [userRights]="userRights"
              [mode]="cardMode"
              (save)="saveEmail($event, EntryType.Opportunity)"
            ></maximizer-outlook-opportunity-card>
          }
        }
      } @else if (entryType === EntryType.Case) {
        @if (cases.length === 0) {
          <div class="py-2">
            <p class="text-neutral-60 text-body">
              {{
                'outlook.main.related.noResults'
                  | translate
                    : {
                        label: 'cases' | translateVertical,
                      }
              }}
            </p>
          </div>
        } @else {
          @for (case of displayedCases; track case.key) {
            <maximizer-outlook-case-card
              [case]="case"
              [userRights]="userRights"
              [mode]="cardMode"
              (save)="saveEmail($event, EntryType.Case)"
            ></maximizer-outlook-case-card>
          }
        }
      }

      @if (scrollToTopVisible) {
        <div class="fixed bottom-10 right-10">
          <maximizer-circle-button
            themeColor="tertiary"
            icon="arrow-up"
            size="small"
            [title]="'outlook.buttons.scrollToTop' | translate"
            (click)="scrollToTop()"
            (keydown.enter)="scrollToTop()"
          ></maximizer-circle-button>
        </div>
      }

      @if (showMoreVisible) {
        <div class="text-center">
          <button
            #showMore
            kendoButton
            themeColor="primary"
            fillMode="flat"
            (click)="onShowMore(); showMore.blur()"
          >
            {{ 'outlook.buttons.showMore' | translate }}
          </button>
        </div>
      }
    }
  </div>
</div>

<maximizer-outlook-notification
  #notification
  [closable]="true"
></maximizer-outlook-notification>

@if (saveEmailDetail) {
  <maximizer-email-detail
    [emailProperties]="saveEmailDetailProperties"
    [entityTypeOverride]="trackingEntryType"
    (saveEmailKey)="onSaveEmailDetail($event.id, $event.type)"
    (closed)="saveEmailDetail = false"
  ></maximizer-email-detail>
}
